import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import TimedRedirect from '../components/TimedRedirect';
import config from '../config';

export default function UserDeleted() {
  return (
    <Container fluid="sm">
      <Row className='mt-2'>
        <Col>
          <h1 className="h3 mb-3 font-weight-normal">Account deleted</h1>
          <TimedRedirect
            className = "mb-3"
            target = {config.links.loginUserType}
            friendlyName = 'the login page'
            message = 'Your user account has been deleted.'
          />
        </Col>
      </Row>
    </Container>
  );
}
